/**
 * Mobile menu — drawer abre/fecha.
 *
 * Triggers:
 *  - click no #menuToggle (em qualquer lado, abre/fecha)
 *  - click num link dentro do drawer (fecha)
 *  - Escape (fecha)
 */

const TOGGLE_ID = 'menuToggle';
const MENU_ID = 'mobileMenu';
const OPEN_CLASS = 'open';

export function initMobileMenu(): () => void {
  const toggle = document.getElementById(TOGGLE_ID);
  const menu = document.getElementById(MENU_ID);
  if (!toggle || !menu) return () => {};

  function setOpen(open: boolean): void {
    if (!toggle || !menu) return;
    menu.classList.toggle(OPEN_CLASS, open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function isOpen(): boolean {
    return menu?.classList.contains(OPEN_CLASS) ?? false;
  }

  const onToggleClick = (): void => setOpen(!isOpen());

  const onLinkClick = (e: Event): void => {
    const target = e.target as Element | null;
    if (!target) return;
    const a = target.closest('a');
    if (a && menu?.contains(a)) {
      setOpen(false);
    }
  };

  const onKey = (e: KeyboardEvent): void => {
    if (e.key === 'Escape' && isOpen()) {
      setOpen(false);
      toggle?.focus();
    }
  };

  toggle.addEventListener('click', onToggleClick);
  menu.addEventListener('click', onLinkClick);
  document.addEventListener('keydown', onKey);

  return () => {
    toggle.removeEventListener('click', onToggleClick);
    menu.removeEventListener('click', onLinkClick);
    document.removeEventListener('keydown', onKey);
  };
}
